import React, { useState } from 'react'
import { useStateValue } from '@State'
import { toast } from '@CommonComponents/toast'
import { client } from '@Utils'
import { codeOrderManagement as endpoints } from '@URLS'

export const RoyaltiesCommissions = () => {
  let [currentState, dispatch] = useStateValue()
  let [requestSent, setRequestSent] = useState(false)

  const sendRequest = () => {
    client
      .get(endpoints.calculate_projections())
      .then(({ data }) => {
        dispatch({
          type: 'updateProjections',
          payload: { royalties: data.royalties, commissions: data.commissions },
        })
        setRequestSent(true)
      })
      .catch(e => {
        console.error(e)
        toast.error(`There was an error while calculating the projections. ${e}`)
      })
  }
  return (
    <React.Fragment>
      {requestSent ||
      (currentState.projections.royalties > 0 &&
        currentState.projections.royalties > 0) ? (
        <span className="font-weight-bold">
          Royalties: ${currentState.projections.royalties} and Commissions: $
          {currentState.projections.commissions}
        </span>
      ) : (
        <button
          onClick={sendRequest}
          className="btn btn-myed btn-default btn-default-myed"
        >
          Calculate Liabilities
        </button>
      )}
    </React.Fragment>
  )
}
